<template>
    <div>
        <form @submit.prevent="next()">

            <div v-if="errors.length" class="alert alert-warning">
                <ul>
                    <li v-for="error in errors">{{ error }}</li>
                </ul>
            </div>
            <div class="form-group row">
                <label class="col-form-label col-md-3" for="matrixName">Decision *</label>
                <div class="col-md">
                    <input type="text" class="form-control" placeholder="Decision to be made" id="matrixName" required v-model="local.matrix.name">
                </div>
            </div>

          <h4>2. Timing</h4>
            <div class="form-group row">
                <label class="col-form-label col-md-3" for="matrixName">Would you like add a timing?</label>
                <div class="col-md-auto">
                    <button type="button" class="btn btn-secondary" @click="toggleTiming">{{toggle ? 'No, Do Not add timing' : 'Yes, add timing'}}</button>
                </div>
            </div>
            <div v-if="toggle" class="form-group row">
                <!--<label class="col-form-label col-md-2" for="matrixTrigger">Trigger</label>
                <div class="col-auto">
                    <input type="date" class="form-control" id="matrixTrigger" v-model="local.matrix.trigger">
                </div>-->
                <div class="col-md offset-3">
                    <input type="text" class="form-control" placeholder="e.g. Monthly" id="timing" v-model="local.matrix.trigger_alt">
                </div>
            </div>

            <div class="row justify-content-center">
                <input type="submit" class="btn btn-success" value="Next">
                <!--<a v-show="!local.matrix.id" class="btn btn-warning" @click="clearLocalData">Clear data</a>-->
            </div>
        </form>
    </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex';

export default {

    data() {
        return {
            toggle: false,

            local: {
                matrix: {},
            },
            errors: [],
        };
    },
    props: [],
    watch: {},
    computed: {
        ...mapState('data', {
            'dataMatrix': state => state.matrix
        }),

        timing: {
            get() {
                if (this.local.matrix.trigger != null || this.local.matrix.trigger_alt != null) {
                    return true;
                }
            }
        }
    },
    methods: {
        next() {
            const vm = this;
            if (vm.validate()) {
                vm.commitMatrix(vm.local.matrix);
                vm.$router.push({name: 'considerations'});
            }
        },
        validate() {
            const vm = this;

            vm.$set(vm, 'errors', []);

            if (_.isEmpty(vm.local.matrix.name)) {
                vm.errors.push('A decision name is required');
            }

            if (!_.isEmpty(vm.local.matrix.trigger) && !vm.local.matrix.trigger.match(new RegExp(/\d{4}-\d{2}-\d{2}/))) {
                vm.errors.push('Trigger must be empty or a valid date');
            }

            return vm.errors.length === 0;
        },
        clearLocalData() {
            this.local.matrix.name = null
            this.local.matrix.trigger = null
            this.local.matrix.trigger_alt = null
            this.local.matrix.considerations = []
            this.local.matrix.decisions = []
            this.local.matrix.scoreCard = {}
            this.commitMatrix(this.local.matrix)
            localStorage.removeItem('data')
        },
        toggleTiming() {
            this.toggle = !this.toggle
            this.local.matrix.trigger = null
            this.local.matrix.trigger_alt = null

        },
        ...mapMutations('data', [
            'commitMatrix'
        ])
    },
    mounted() {
        //this.commitMatrix(this.matrix); //in edit, mutate matrix
        this.local.matrix = { ...this.dataMatrix }

        if (this.local.matrix.trigger != null || this.local.matrix.trigger_alt != null) {
            this.toggle = true
        }

    },

    //TODO: Warn on changes not saved

  beforeRouteLeave (to, from, next) {

    let matrixId = this.local.matrix.id
    let nextLinks = ['considerations', 'conditions', 'scores', 'decisiontable', 'scoreassessment', 'scenariotesting']

    if(_.isUndefined(matrixId)) {
      if(nextLinks.includes(to.name)) {
        if (this.validate()) {
          next()
        }
      }else{
        next()
      }

    }else{
      next()
    }
  },

};
</script>
